// Product Video Player
class ProductVideo {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.container = document.querySelector(`[data-section-id="${sectionId}"]`);
    
    if (!this.container) {
      console.error(`Section ${sectionId} not found`);
      return;
    }
    
    // Get elements
    this.videoCover = this.container.querySelector(`#pvsVideoCover-${sectionId}`);
    this.videoPlayer = this.container.querySelector(`#pvsVideoPlayer-${sectionId}`);
    
    if (!this.videoCover || !this.videoPlayer) {
      console.error(`Video elements not found in section ${sectionId}`);
      return;
    }
    
    this.init();
  }
  
  init() {
    this.setupEventListeners();
  }
  
  setupEventListeners() {
    // Cover click to play video
    this.videoCover.addEventListener('click', (e) => {
      e.preventDefault();
      this.playVideo();
    });
    
    // Play button click
    const playButton = this.videoCover.querySelector('.pvs-play-button');
    if (playButton) {
      playButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.playVideo();
      });
    }
  }
  
  playVideo() {
    // Hide cover, show player
    this.videoCover.style.display = 'none';
    this.videoPlayer.style.display = 'block';
    
    // Get video type and ID
    const iframe = this.videoPlayer.querySelector('iframe');
    if (!iframe) return;
    
    const currentSrc = iframe.src;
    
    // Add autoplay parameter if not already present
    if (currentSrc.includes('youtube.com')) {
      if (!currentSrc.includes('autoplay=1')) {
        const separator = currentSrc.includes('?') ? '&' : '?';
        iframe.src = `${currentSrc}${separator}autoplay=1&rel=0&modestbranding=1`;
      }
    } else if (currentSrc.includes('vimeo.com')) {
      if (!currentSrc.includes('autoplay=1')) {
        const separator = currentSrc.includes('?') ? '&' : '?';
        iframe.src = `${currentSrc}${separator}autoplay=1`;
      }
    }
    
    console.log(`Product Video ${this.sectionId}: Video started playing`);
  }
}

// Initialize all Product Video sections
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-id]');
  
  sections.forEach(section => {
    const sectionId = section.dataset.sectionId;
    const hasProductVideo = section.querySelector('.pvs-section');
    
    if (hasProductVideo) {
      new ProductVideo(sectionId);
    }
  });
});

// For Shopify theme editor
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', (event) => {
    const sectionId = event.detail.sectionId;
    
    setTimeout(() => {
      const section = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (section && section.querySelector('.pvs-section')) {
        new ProductVideo(sectionId);
      }
    }, 100);
  });
}

// Simple click handler for backup
document.addEventListener('DOMContentLoaded', function() {
  // Add click handler for all video covers
  document.querySelectorAll('.pvs-video-cover').forEach(cover => {
    cover.addEventListener('click', function() {
      const container = this.closest('.pvs-video-container');
      const player = container?.querySelector('.pvs-video-player');
      
      if (player) {
        this.style.display = 'none';
        player.style.display = 'block';
        
        // Trigger autoplay for iframe
        const iframe = player.querySelector('iframe');
        if (iframe) {
          const src = iframe.src;
          if (!src.includes('autoplay=1')) {
            const separator = src.includes('?') ? '&' : '?';
            iframe.src = `${src}${separator}autoplay=1`;
          }
        }
      }
    });
  });
});